// extracted by mini-css-extract-plugin
module.exports = {"revealArea":"QuizCard_revealArea__gMgHP"};